module.exports = __webpack_public_path__ + "../resources/graphql/schema.all.min-532f687466109829382b6fba792b62e6.graphql";